import { defineComponent, inject, computed, ref, createElementBlock, openBlock, createElementVNode, createVNode, unref, normalizeClass, toDisplayString, withDirectives, vShow, withCtx, createBlock, createSlots, createCommentVNode, createTextVNode } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "@nuxt/ui/composables/useToast";
import { addKontyToast } from "app-theme";
import { Icon } from "@iconify/vue";
import UButton from "@nuxt/ui/components/Button.vue";
import UProgress from "@nuxt/ui/components/Progress.vue";
import UFormField from "@nuxt/ui/components/FormField.vue";
import UInput from "@nuxt/ui/components/Input.vue";
import USelect from "@nuxt/ui/components/Select.vue";
import UTextarea from "@nuxt/ui/components/Textarea.vue";
import { useSheetLayer, useSheetLayerGuard, SHEET_LEADING_CONTROL_CLASS } from "./index48.js";
import { maskito } from "@maskito/vue";
import { Store, ClientIDType, Pricelist, Countries, I18n } from "app-core";
import { useMaskito } from "./index51.js";
import { useClientForm } from "./index40.js";
import _sfc_main$1 from "./index29.js";
const _hoisted_1 = { class: "flex h-full min-h-0 flex-col" };
const _hoisted_2 = { class: "flex shrink-0 items-center gap-2 px-3 pt-3" };
const _hoisted_3 = { class: "truncate text-panel-title" };
const _hoisted_4 = { class: "h-1 shrink-0" };
const _hoisted_5 = { class: "min-h-0 flex-1 overflow-y-auto p-4" };
const _hoisted_6 = { class: "flex flex-col gap-4" };
const _hoisted_7 = { class: "flex items-start gap-3" };
const _hoisted_8 = { class: "row-icon" };
const _hoisted_9 = { class: "grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2" };
const _hoisted_10 = { class: "flex items-start gap-3" };
const _hoisted_11 = { class: "row-icon" };
const _hoisted_12 = { class: "grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2" };
const _hoisted_13 = { class: "flex items-start gap-3" };
const _hoisted_14 = { class: "row-icon" };
const _hoisted_15 = { class: "grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2" };
const _hoisted_16 = { class: "flex items-start gap-3" };
const _hoisted_17 = { class: "row-icon" };
const _hoisted_18 = { class: "grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2" };
const _hoisted_19 = { class: "flex items-start gap-3" };
const _hoisted_20 = { class: "row-icon" };
const _hoisted_21 = { class: "grid flex-1 grid-cols-1 gap-4 sm:grid-cols-2" };
const _hoisted_22 = { class: "flex items-center gap-1.5" };
const _hoisted_23 = { class: "flex items-start gap-3" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ClientForm",
  props: {
    client: {
      type: Object,
      default: () => void 0
    },
    /** AD-4: the API prefix — POS omits it (`/clients`), admin passes '/admin'. */
    endpointBase: {
      type: String,
      default: ""
    },
    /** Pricelist options override — defaults to the Pricelist model (POS). */
    pricelists: {
      type: Array,
      default: () => void 0
    },
    onSave: {
      type: Function,
      default: () => {
      }
    },
    onCancel: {
      type: Function,
      default: () => {
      }
    }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const { t } = useI18n();
    const { buyerCostCenterMask, taxIdNumberMask, taxIdNumberJbkjsMask, personalIdNumberMask, emptyMask, createNumberMask } = useMaskito();
    const costCenterMask = buyerCostCenterMask();
    const backoffice = inject("kontyBackoffice", false);
    const { nested } = useSheetLayer();
    useSheetLayerGuard();
    const footerClass = computed(
      () => "flex min-h-17 shrink-0 items-center gap-2 px-4 py-3 *:flex-1" + (backoffice ? " sm:justify-end sm:*:flex-none" : "")
    );
    const buttonSize = backoffice ? "md" : "lg";
    const nuxtToast = useToast();
    const toast = inject("kontyToast", (message, status) => {
      addKontyToast(nuxtToast, { description: message, color: status === "error" ? "error" : "success" });
    });
    const { form, idTypes, detecting, validateField, detect, save } = useClientForm(props.client, { endpointBase: props.endpointBase });
    const discountPercentMask = createNumberMask({ precision: 2, min: 0, max: 99 });
    const modules = Store.get("modules");
    const enablePricelists = ref(!(modules == null ? void 0 : modules.inventory_accounting) && !Store.get("isRetail") && !!(modules == null ? void 0 : modules.pricelists));
    const idNumberMask = computed(() => {
      if (form.data.id_type === ClientIDType.tax_id_number || form.data.id_type === ClientIDType.tax_id_number_local) {
        return taxIdNumberMask();
      }
      if (form.data.id_type === ClientIDType.tax_id_number_local_jbkjs) return taxIdNumberJbkjsMask();
      if (form.data.id_type === ClientIDType.personal_id_number_local) return personalIdNumberMask();
      return emptyMask;
    });
    const idTypeItems = computed(() => idTypes.value.map((idType) => ({ label: idType.text, value: idType.id })));
    const pricelistItems = computed(() => props.pricelists ?? Pricelist.all().map((pricelist) => ({ label: pricelist.name || "", value: pricelist.id })));
    function errText(field) {
      const messages = form.errors.value.filter((e) => e.name === field).map((e) => e.message);
      return messages.length ? messages[0] : void 0;
    }
    async function submit() {
      const result = await save();
      if (result.status === "offline") {
        toast(t("connection.internet_offline_message_not_allowed"), "error");
        return;
      }
      if (result.status === "saved") {
        toast(t("general.client_saved"), "success");
        props.onSave(result.client);
      }
      if (result.status === "error" && !form.errors.value.length) {
        toast(t("general.error_message"), "error");
      }
    }
    __expose({ submit, busy: form.busy, detecting });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          createVNode(UButton, {
            color: "neutral",
            variant: "ghost",
            size: "md",
            class: normalizeClass(unref(backoffice) ? void 0 : unref(SHEET_LEADING_CONTROL_CLASS)),
            icon: unref(nested) ? "i-lucide-chevron-left" : "i-lucide-x",
            "aria-label": unref(nested) ? unref(t)("general.back") : unref(t)("general.close"),
            onClick: __props.onCancel
          }, null, 8, ["class", "icon", "aria-label", "onClick"]),
          createElementVNode("h2", _hoisted_3, toDisplayString(unref(t)("general.client")), 1)
        ]),
        createElementVNode("div", _hoisted_4, [
          withDirectives(createVNode(UProgress, { size: "sm" }, null, 512), [
            [vShow, unref(detecting)]
          ])
        ]),
        createElementVNode("div", _hoisted_5, [
          createElementVNode("div", _hoisted_6, [
            createElementVNode("div", _hoisted_7, [
              createElementVNode("div", _hoisted_8, [
                createVNode(unref(Icon), {
                  icon: "lucide:user",
                  class: "size-4.5 shrink-0"
                })
              ]),
              createElementVNode("div", _hoisted_9, [
                createVNode(UFormField, {
                  label: unref(t)("general.name"),
                  error: errText("name")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => unref(form).data.name = $event),
                      class: "w-full",
                      onInput: _cache[1] || (_cache[1] = ($event) => unref(form).clearErrors("name")),
                      onBlur: _cache[2] || (_cache[2] = ($event) => unref(validateField)("name"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.buyer_cost_center"),
                  error: errText("cost_center")
                }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(UInput, {
                      modelValue: unref(form).data.cost_center,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => unref(form).data.cost_center = $event),
                      class: "w-full",
                      onInput: _cache[4] || (_cache[4] = ($event) => unref(form).clearErrors("cost_center")),
                      onBlur: _cache[5] || (_cache[5] = ($event) => unref(validateField)("cost_center"))
                    }, null, 8, ["modelValue"]), [
                      [unref(maskito), unref(costCenterMask)]
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "error"])
              ])
            ]),
            createElementVNode("div", _hoisted_10, [
              createElementVNode("div", _hoisted_11, [
                createVNode(unref(Icon), {
                  icon: "lucide:phone",
                  class: "size-4.5 shrink-0"
                })
              ]),
              createElementVNode("div", _hoisted_12, [
                createVNode(UFormField, {
                  label: unref(t)("general.phone"),
                  error: errText("phone")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.phone,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => unref(form).data.phone = $event),
                      class: "w-full",
                      onInput: _cache[7] || (_cache[7] = ($event) => unref(form).clearErrors("phone")),
                      onBlur: _cache[8] || (_cache[8] = ($event) => unref(validateField)("phone"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.email"),
                  error: errText("email")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.email,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => unref(form).data.email = $event),
                      class: "w-full",
                      onInput: _cache[10] || (_cache[10] = ($event) => unref(form).clearErrors("email")),
                      onBlur: _cache[11] || (_cache[11] = ($event) => unref(validateField)("email"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"])
              ])
            ]),
            createElementVNode("div", _hoisted_13, [
              createElementVNode("div", _hoisted_14, [
                createVNode(unref(Icon), {
                  icon: "lucide:map-pin",
                  class: "size-4.5 shrink-0"
                })
              ]),
              createElementVNode("div", _hoisted_15, [
                createVNode(UFormField, {
                  label: unref(t)("general.address"),
                  error: errText("address")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.address,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => unref(form).data.address = $event),
                      class: "w-full",
                      onInput: _cache[13] || (_cache[13] = ($event) => unref(form).clearErrors("address")),
                      onBlur: _cache[14] || (_cache[14] = ($event) => unref(validateField)("address"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.postal_number"),
                  error: errText("postal_number")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.postal_number,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => unref(form).data.postal_number = $event),
                      class: "w-full",
                      onInput: _cache[16] || (_cache[16] = ($event) => unref(form).clearErrors("postal_number")),
                      onBlur: _cache[17] || (_cache[17] = ($event) => unref(validateField)("postal_number"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.city"),
                  error: errText("city")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.city,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => unref(form).data.city = $event),
                      class: "w-full",
                      onInput: _cache[19] || (_cache[19] = ($event) => unref(form).clearErrors("city")),
                      onBlur: _cache[20] || (_cache[20] = ($event) => unref(validateField)("city"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.country"),
                  error: errText("country")
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$1, {
                      modelValue: unref(form).data.country,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => unref(form).data.country = $event),
                      placeholder: unref(t)("general.country_placeholder"),
                      items: unref(Countries).data,
                      "item-key": "alpha3Code",
                      "item-value": "alpha3Code",
                      "item-text": "name"
                    }, null, 8, ["modelValue", "placeholder", "items"])
                  ]),
                  _: 1
                }, 8, ["label", "error"])
              ])
            ]),
            createElementVNode("div", _hoisted_16, [
              createElementVNode("div", _hoisted_17, [
                createVNode(unref(Icon), {
                  icon: "lucide:id-card",
                  class: "size-4.5 shrink-0"
                })
              ]),
              createElementVNode("div", _hoisted_18, [
                createVNode(UFormField, {
                  label: unref(t)("general.id_type"),
                  error: errText("id_type")
                }, {
                  default: withCtx(() => [
                    createVNode(USelect, {
                      modelValue: unref(form).data.id_type,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => unref(form).data.id_type = $event),
                      class: "w-full",
                      items: idTypeItems.value,
                      disabled: unref(I18n).c("general.country") === "MNE" && unref(form).data.country === "MNE",
                      onBlur: _cache[23] || (_cache[23] = ($event) => unref(validateField)("id_type"))
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.id_number"),
                  error: errText("id_number")
                }, {
                  default: withCtx(() => [
                    withDirectives((openBlock(), createBlock(UInput, {
                      modelValue: unref(form).data.id_number,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => unref(form).data.id_number = $event),
                      class: "w-full",
                      onInput: _cache[26] || (_cache[26] = ($event) => unref(form).clearErrors("id_number")),
                      onBlur: _cache[27] || (_cache[27] = ($event) => unref(form).validate())
                    }, createSlots({ _: 2 }, [
                      unref(I18n).c("client.detectable") && unref(form).data.id_number ? {
                        name: "trailing",
                        fn: withCtx(() => [
                          createVNode(UButton, {
                            color: "neutral",
                            variant: "ghost",
                            size: "sm",
                            "aria-label": unref(t)("general.search"),
                            onClick: _cache[24] || (_cache[24] = ($event) => unref(detect)())
                          }, {
                            default: withCtx(() => [
                              createVNode(unref(Icon), {
                                icon: "lucide:search",
                                class: "size-4.5 shrink-0"
                              })
                            ]),
                            _: 1
                          }, 8, ["aria-label"])
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1032, ["modelValue"])), [
                      [unref(maskito), idNumberMask.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.registration_number"),
                  error: errText("registration_number")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.registration_number,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => unref(form).data.registration_number = $event),
                      class: "w-full",
                      onInput: _cache[29] || (_cache[29] = ($event) => unref(form).clearErrors("registration_number")),
                      onBlur: _cache[30] || (_cache[30] = ($event) => unref(validateField)("registration_number"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.vat_number"),
                  error: errText("vat_number")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.vat_number,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => unref(form).data.vat_number = $event),
                      class: "w-full",
                      onInput: _cache[32] || (_cache[32] = ($event) => unref(form).clearErrors("vat_number")),
                      onBlur: _cache[33] || (_cache[33] = ($event) => unref(validateField)("vat_number"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.buyer_card_number"),
                  error: errText("card")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.card,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => unref(form).data.card = $event),
                      class: "w-full",
                      onInput: _cache[35] || (_cache[35] = ($event) => unref(form).clearErrors("card")),
                      onBlur: _cache[36] || (_cache[36] = ($event) => unref(validateField)("card"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "error"]),
                createVNode(UFormField, {
                  label: unref(t)("general.tax_id_card_number"),
                  help: unref(t)("general.tax_id_card_number_description"),
                  error: errText("tax_id_card_number")
                }, {
                  default: withCtx(() => [
                    createVNode(UInput, {
                      modelValue: unref(form).data.tax_id_card_number,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => unref(form).data.tax_id_card_number = $event),
                      class: "w-full",
                      onInput: _cache[38] || (_cache[38] = ($event) => unref(form).clearErrors("tax_id_card_number")),
                      onBlur: _cache[39] || (_cache[39] = ($event) => unref(validateField)("tax_id_card_number"))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "help", "error"])
              ])
            ]),
            createElementVNode("div", _hoisted_19, [
              createElementVNode("div", _hoisted_20, [
                createVNode(unref(Icon), {
                  icon: "lucide:tag",
                  class: "size-4.5 shrink-0"
                })
              ]),
              createElementVNode("div", _hoisted_21, [
                createVNode(UFormField, {
                  label: unref(t)("general.discount"),
                  error: errText("discount_percent"),
                  class: normalizeClass({ "sm:col-span-2": !enablePricelists.value })
                }, {
                  default: withCtx(() => [
                    withDirectives((openBlock(), createBlock(UInput, {
                      modelValue: unref(form).data.discount_percent,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => unref(form).data.discount_percent = $event),
                      class: "w-full",
                      onInput: _cache[41] || (_cache[41] = ($event) => unref(form).clearErrors("discount_percent")),
                      onBlur: _cache[42] || (_cache[42] = ($event) => unref(validateField)("discount_percent"))
                    }, {
                      trailing: withCtx(() => [
                        createVNode(unref(Icon), {
                          icon: "lucide:percent",
                          class: "size-4 shrink-0"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])), [
                      [unref(maskito), unref(discountPercentMask)]
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "error", "class"]),
                enablePricelists.value ? (openBlock(), createBlock(UFormField, {
                  key: 0,
                  label: unref(t)("general.pricelist"),
                  error: errText("pricelist_id")
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_22, [
                      createVNode(USelect, {
                        modelValue: unref(form).data.pricelist_id,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => unref(form).data.pricelist_id = $event),
                        class: "flex-1",
                        items: pricelistItems.value,
                        onBlur: _cache[44] || (_cache[44] = ($event) => unref(validateField)("pricelist_id"))
                      }, null, 8, ["modelValue", "items"]),
                      !!unref(form).data.pricelist_id ? (openBlock(), createBlock(UButton, {
                        key: 0,
                        icon: "i-lucide-x",
                        color: "neutral",
                        variant: "link",
                        size: "sm",
                        "aria-label": unref(t)("general.close"),
                        onClick: _cache[45] || (_cache[45] = ($event) => unref(form).data.pricelist_id = void 0)
                      }, null, 8, ["aria-label"])) : createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "error"])) : createCommentVNode("", true)
              ])
            ]),
            createElementVNode("div", _hoisted_23, [
              _cache[49] || (_cache[49] = createElementVNode("div", { class: "row-icon" }, null, -1)),
              createVNode(UFormField, {
                class: "flex-1",
                label: unref(t)("general.comment"),
                error: errText("comment")
              }, {
                default: withCtx(() => [
                  createVNode(UTextarea, {
                    modelValue: unref(form).data.comment,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => unref(form).data.comment = $event),
                    class: "w-full",
                    autoresize: "",
                    onInput: _cache[47] || (_cache[47] = ($event) => unref(form).clearErrors("comment")),
                    onBlur: _cache[48] || (_cache[48] = ($event) => unref(validateField)("comment"))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label", "error"])
            ])
          ])
        ]),
        createElementVNode("div", {
          class: normalizeClass(footerClass.value)
        }, [
          createVNode(UButton, {
            size: unref(buttonSize),
            color: "neutral",
            variant: "outline",
            onClick: __props.onCancel
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("general.cancel")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"]),
          createVNode(UButton, {
            size: unref(buttonSize),
            color: "primary",
            variant: "solid",
            icon: "i-lucide-check",
            onClick: submit
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("general.save")), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ], 2)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index93.js.map
